import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=13b8c980&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=13b8c980&lang=scss&scoped=true"
import style1 from "./CreatePost.vue?vue&type=style&index=1&id=13b8c980&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8c980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b8c980')) {
      api.createRecord('13b8c980', component.options)
    } else {
      api.reload('13b8c980', component.options)
    }
    module.hot.accept("./CreatePost.vue?vue&type=template&id=13b8c980&scoped=true", function () {
      api.rerender('13b8c980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SingleView/CreatePost.vue"
export default component.exports